import benefitsGraphic from "@/shared/assets/illustrations/benefits-graphic.svg";

import type { FlowScreenConfig } from "@/shared/constants/flowTypes";
import { LifeInsuranceReview } from "../components/LifeInsuranceReview";
import { AddLifeInsurance } from "../components/AddLifeInsurance";

export function createLifeInsuranceScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "benefits_intro",
      layout: "full",
      imageSrc: benefitsGraphic,
      imageSize: "md",
      imagePosition: "right",
      verticalCenter: true,
      maxWidth: "4xl",
      title: `Let's identify ${firstName}'s benefits and insurance`,
      subtitle:
        "We'll help you uncover any life insurance, pensions, veterans benefits, or government benefits your family may be entitled to.",
      getButtonText: () => "Get started",
    },
    {
      id: "life_insurance_review",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: LifeInsuranceReview,
      shouldDisplay: ({ answers }) =>
        !answers["has_life_insurance"] && answers["life_insurance_review"] !== "none",
    },
    {
      id: "has_life_insurance",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: `Did ${firstName} have life insurance?`,
      subtitle:
        "This could be through an employer (group life) or a personal policy (term, whole, or universal life).",
      question: {
        type: "multiple_choice",
        required: true,
        options: [
          { value: "yes", label: "Yes, they had life insurance" },
          { value: "no", label: "No life insurance" },
          { value: "not_sure", label: "I'm not sure" },
        ],
      },
      shouldDisplay: ({ answers }) => answers["life_insurance_review"] === "none",
    },
    {
      id: "add_life_insurance",
      layout: "full",
      maxWidth: "4xl",
      hideButton: true,
      customComponent: AddLifeInsurance,
      shouldDisplay: ({ answers }) =>
        answers["has_life_insurance"] === "yes" &&
        (answers["add_life_insurance"] === "yes" || answers["life_insurance_review"] === "none"),
    },
    {
      id: "life_insurance_manage",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: LifeInsuranceReview,
      shouldDisplay: ({ answers }) =>
        answers["life_insurance_review"] === "found" && answers["life_insurance_manage"] === "yes",
    },
  ];
}
